import { Observable } from "rxjs";
import { ObservableFromFetch } from "../ObservableFromFetch"
import DonorRecord from "../Randoms/RandomsModel/DonorRecord"

export function GovDonorAddObservable(data: DonorRecord): Observable<string> {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<string>("GovDonor/CreateDonor", params)
}
